export const passwordValidationRegex = new RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z-_@$!%*.+=~{}\\|/\[\],#?&<>()^]{8,32}$/);



// WEBPACK FOOTER //
// ./src/utils/passwordValidationRegex.js